import { useState } from 'react'
import { Maximize2 } from 'lucide-react'
import uiScreens from '../content/uiScreens.json'

// Real 23Controls™ interface captures, keyed by AI Operations Suite step id.
// Written by scripts/capture-23controls-ui.mjs; empty until captures exist.
export function screensFor(stepId) {
  return uiScreens[stepId] ?? []
}

export default function UIScreens({ screens }) {
  const [active, setActive] = useState(0)
  const shot = screens[Math.min(active, screens.length - 1)]
  if (!shot) return null

  return (
    <figure className="rounded-2xl border border-void-700/60 bg-void-950 shadow-2xl shadow-void-950/80 overflow-hidden">
      <div className="flex items-center justify-between gap-3 px-4 py-2.5 border-b border-void-800 bg-void-900/80">
        <span className="font-mono text-[11px] text-void-400 truncate">23controls.com{shot.route}</span>
        <span className="text-[10px] uppercase tracking-wider text-emerald-300 shrink-0">Actual interface</span>
      </div>
      <a href={shot.src} target="_blank" rel="noreferrer" className="group relative block">
        <img src={shot.src} alt={shot.alt} loading="lazy" className="w-full h-auto block" />
        <span className="absolute top-3 right-3 p-1.5 rounded-md bg-void-950/80 text-void-300 opacity-0 group-hover:opacity-100 transition-opacity">
          <Maximize2 className="w-4 h-4" />
        </span>
      </a>
      <figcaption className="px-4 py-3 border-t border-void-800 text-xs text-void-400 flex flex-wrap items-center gap-3">
        <span className="flex-1 min-w-[12rem]">{shot.caption}</span>
        {screens.length > 1 && (
          <span className="flex gap-1.5">
            {screens.map((s, i) => (
              <button
                key={s.src}
                onClick={() => setActive(i)}
                className={`px-2 py-0.5 rounded-md border text-[11px] ${
                  i === active ? 'border-synth-500/60 text-synth-200 bg-synth-900/40' : 'border-void-700 text-void-500 hover:text-void-300'
                }`}
              >
                {s.label}
              </button>
            ))}
          </span>
        )}
      </figcaption>
    </figure>
  )
}
